import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { T2TRolesContainerModel } from "../../../../../models/aggregates/t2t/t2t-roles-container.model";

import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../shared";

@Injectable({
  providedIn: "root",
})
export class T2TRolesService extends BaseApiTemplateService<T2TRolesContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.T2T_DOMAIN_URL_PREFIX +
      Core2Config.CONFIG_PREFIX +
      Core2Config.ERP_PREFIX +
      "roles";
    this.httpClient = http;
  }
}
